// extracted by mini-css-extract-plugin
export default {"field-container":"VirginEmailTemplateEditor_field-container__kwK+G","form":"VirginEmailTemplateEditor_form__ZCzJ7"};